import {
	API_GET_ALL_TUBELIBRARY,
	API_GET_ALL_TUBELIBRARY_FAIL,
	API_GET_ALL_TUBELIBRARY_SUCCESS,
} from '../actions/tubeLibrary';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
	loading: false,
	list: []
};

const tubeReasons = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_TUBELIBRARY]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_TUBELIBRARY_FAIL]: (state, action) => {
		errorHandler('Catalogue de tube', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_TUBELIBRARY_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default tubeReasons;
